export default Object.freeze({
    New: 1,
    Submitted: 2,
    ReturnedForReview: 3,
    ReturnedProcess: 4,
    SubmittedReviewed: 5,
    PendingApproval: 6,
    Approved: 7,
    SentToFinance: 8,
    Paid: 9,
    Cancelled: 10,
    InPaymentProcess: 11,
})